// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.
//
console.log("Hello from index.js");

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";

// Call the menu and infinite scroll functions
menuOpen();
// infiniteScroll();

function renderInPopUp() {
    let popEl = document.querySelector(".calendly-overlay .calendly-popup ");

    let siEl = document.createElement("div");
    siEl.classList.add("si-calendly-content");

    siEl.innerHTML = `
              <div class="call">Option #1 CHAT WITH US LIVE</div>
              <a class="whatsApp-button" href="https://wa.me/19157026993"
                ><img src="/assets/whatsapp.png" />
                +1 915-702-6993
              </a>
              <div class="cal-msg">Option #2 Schedule an Appointment</div>
`;

    popEl.prepend(siEl);
}

function handleClick(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    // eslint-disable-next-line no-undef
    Calendly.initPopupWidget({
        url: "https://calendly.com/actiontd/eric_for_30_safety_intel?hide_event_type_details=1&hide_gdpr_banner=1"
    });
    renderInPopUp();

    // function isCalendlyEvent(e) {
    //     return e.data.event && e.data.event.indexOf("calendly") === 0;
    // }
    // window.addEventListener("message", function (e) {
    //     console.log(e.data);
    //     // eslint-disable-next-line no-undef
    //     // if (isCalendlyEvent(e)) {
    //     //     console.log(e.data);
    //     // }
    // });
    return false;
}

let ctaEls = document.querySelectorAll('[href*="portal"]');
ctaEls.forEach((c) => {
    console.log(c);
    c.addEventListener("click", handleClick);
});

//dev con
//
//
// document.querySelector(".si-button").click();
